import { Controller } from "@hotwired/stimulus"
import { metric, dynos } from "../../lib/helpers"
import { reactor } from "../../lib/reactor"

export default class extends Controller {
  static values = {
    notify: Boolean,
    quantity: Number,
    after: Number
  }

  connect() {
    reactor(this)
  }

  quantityPhrase() {
    if (this.quantityValue === 0) return "1 or more dynos"
    if (this.quantityValue === 1) return "more than 1 dyno"
    return `more than ${this.quantityValue} dynos`
  }

  quantityDescription() {
    return `A notification is sent when running ${dynos(this.quantityPhrase())}.`
  }

  afterDescription() {
    if (!this.afterValue)
      return `Sent immediately, with no delay.`

    if (this.afterValue === 1)
      return `The count must hold for ${metric("1 hour")}.`

    return `The count must hold for ${metric(`${this.afterValue} hours`)}.`
  }

  description() {
    if (!this.afterValue)
      return `Send a notification immediately when running ${dynos(this.quantityPhrase())}.`

    const delay = (this.afterValue === 1) ? "1 hour" : `${this.afterValue} hours`
    return `Send a notification when running ${dynos(this.quantityPhrase())} for at least ${metric(delay)}.`
  }
}
